"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductConfiguration = exports.TagTypes = exports.ProductGroup = exports.ModificationType = exports.ProductBatchUpdateType = exports.VariantType = exports.ProductType = void 0;
var ProductType;
(function (ProductType) {
    ProductType[ProductType["Standard"] = 0] = "Standard";
    ProductType[ProductType["Bottle"] = 1] = "Bottle";
    ProductType[ProductType["Volume"] = 2] = "Volume";
    ProductType[ProductType["Weight"] = 3] = "Weight";
    ProductType[ProductType["TimeBased"] = 4] = "TimeBased";
    ProductType[ProductType["GiftCard"] = 5] = "GiftCard";
    ProductType[ProductType["PrepaidWallet"] = 6] = "PrepaidWallet";
    ProductType[ProductType["MultiProduct"] = 7] = "MultiProduct";
    ProductType[ProductType["Retain24GiftCard"] = 8] = "Retain24GiftCard";
    ProductType[ProductType["MPSGiftCard"] = 9] = "MPSGiftCard";
    ProductType[ProductType["Stammy"] = 10] = "Stammy";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var VariantType;
(function (VariantType) {
    VariantType[VariantType["Standard"] = 0] = "Standard";
    VariantType[VariantType["Glass"] = 1] = "Glass";
    VariantType[VariantType["Bottle"] = 2] = "Bottle";
    VariantType[VariantType["Volume"] = 3] = "Volume";
    VariantType[VariantType["Weight"] = 4] = "Weight";
    VariantType[VariantType["TimeBased"] = 5] = "TimeBased";
    VariantType[VariantType["CardTopUp"] = 6] = "CardTopUp";
    VariantType[VariantType["MultiProduct"] = 7] = "MultiProduct";
})(VariantType = exports.VariantType || (exports.VariantType = {}));
var ProductBatchUpdateType;
(function (ProductBatchUpdateType) {
    ProductBatchUpdateType[ProductBatchUpdateType["AvailabilityHour"] = 1] = "AvailabilityHour";
    ProductBatchUpdateType[ProductBatchUpdateType["Visibility"] = 2] = "Visibility";
    ProductBatchUpdateType[ProductBatchUpdateType["AutoAccept"] = 4] = "AutoAccept";
    ProductBatchUpdateType[ProductBatchUpdateType["BlockProduct"] = 8] = "BlockProduct";
    ProductBatchUpdateType[ProductBatchUpdateType["ProductGroup"] = 16] = "ProductGroup";
    ProductBatchUpdateType[ProductBatchUpdateType["MenuGroup"] = 32] = "MenuGroup";
    ProductBatchUpdateType[ProductBatchUpdateType["OutletShares"] = 64] = "OutletShares";
    ProductBatchUpdateType[ProductBatchUpdateType["UpsellGroups"] = 128] = "UpsellGroups";
    ProductBatchUpdateType[ProductBatchUpdateType["TicketDestination"] = 256] = "TicketDestination";
    ProductBatchUpdateType[ProductBatchUpdateType["AddonGroups"] = 512] = "AddonGroups";
    ProductBatchUpdateType[ProductBatchUpdateType["Course"] = 1024] = "Course";
    ProductBatchUpdateType[ProductBatchUpdateType["StorageInformation"] = 2048] = "StorageInformation";
})(ProductBatchUpdateType = exports.ProductBatchUpdateType || (exports.ProductBatchUpdateType = {}));
var ModificationType;
(function (ModificationType) {
    ModificationType["Add"] = "Add";
    ModificationType["Remove"] = "Remove";
    ModificationType["Replace"] = "Replace";
})(ModificationType = exports.ModificationType || (exports.ModificationType = {}));
var ProductGroup;
(function (ProductGroup) {
    ProductGroup[ProductGroup["Standard"] = 0] = "Standard";
    ProductGroup[ProductGroup["GiftCards"] = 1] = "GiftCards";
    ProductGroup[ProductGroup["PrepaidWallet"] = 2] = "PrepaidWallet";
    ProductGroup[ProductGroup["Retain24GiftCards"] = 3] = "Retain24GiftCards";
    ProductGroup[ProductGroup["MPSGiftCards"] = 4] = "MPSGiftCards";
    ProductGroup[ProductGroup["Stammy"] = 5] = "Stammy";
})(ProductGroup = exports.ProductGroup || (exports.ProductGroup = {}));
var TagTypes;
(function (TagTypes) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    TagTypes[TagTypes["ProductGroup"] = 1] = "ProductGroup";
    TagTypes[TagTypes["Product"] = 2] = "Product";
})(TagTypes = exports.TagTypes || (exports.TagTypes = {}));
var ProductConfiguration;
(function (ProductConfiguration) {
    ProductConfiguration[ProductConfiguration["Standard"] = 0] = "Standard";
    ProductConfiguration[ProductConfiguration["OutletSpecific"] = 1] = "OutletSpecific";
})(ProductConfiguration = exports.ProductConfiguration || (exports.ProductConfiguration = {}));
